import { render, staticRenderFns } from "./DetailItemEmployeeCard.vue?vue&type=template&id=63c37fee"
import script from "./DetailItemEmployeeCard.vue?vue&type=script&lang=js"
export * from "./DetailItemEmployeeCard.vue?vue&type=script&lang=js"
import style0 from "./DetailItemEmployeeCard.vue?vue&type=style&index=0&id=63c37fee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports